module.exports = __webpack_public_path__ + "img/feature-item-stats.3e1eb5d5.svg";